export type CoworkIntegrationCatalogItem = {
  label: string
  logoPath: string
  description: keyof typeof import("@/i18n/en").dict
  category?: keyof typeof import("@/i18n/en").dict
  canConnect: boolean
  providerKey?: string
}

export const coworkIntegrationCatalog: readonly CoworkIntegrationCatalogItem[] = [
  {
    label: "Google Drive",
    logoPath: "/template-logos/google-drive.svg",
    description: "cowork.integrations.description.google-drive",
    category: "cowork.enterprise.integrations.category.files",
    canConnect: true,
    providerKey: "google-drive",
  },
  {
    label: "OneDrive",
    logoPath: "/template-logos/one-drive.svg",
    description: "cowork.integrations.description.one-drive",
    category: "cowork.enterprise.integrations.category.files",
    canConnect: true,
    providerKey: "one-drive",
  },
  {
    label: "SharePoint",
    logoPath: "/template-logos/sharepoint-online.svg",
    description: "cowork.integrations.description.sharepoint-online",
    category: "cowork.enterprise.integrations.category.files",
    canConnect: true,
    providerKey: "sharepoint-online",
  },
  {
    label: "Slack",
    logoPath: "/template-logos/slack.svg",
    description: "cowork.integrations.description.slack",
    category: "cowork.enterprise.integrations.category.collaboration",
    canConnect: false,
  },
  {
    label: "Microsoft Teams",
    logoPath: "/template-logos/microsoft-teams.svg",
    description: "cowork.integrations.description.microsoft-teams",
    category: "cowork.enterprise.integrations.category.collaboration",
    canConnect: false,
  },
  {
    label: "Salesforce",
    logoPath: "/template-logos/salesforce.svg",
    description: "cowork.integrations.description.salesforce",
    category: "cowork.enterprise.integrations.category.businessSystems",
    canConnect: false,
  },
  {
    label: "Airtable",
    logoPath: "/template-logos/airtable.svg",
    description: "cowork.integrations.description.airtable",
    category: "cowork.enterprise.integrations.category.data",
    canConnect: false,
  },
  {
    label: "Xero",
    logoPath: "/template-logos/xero.svg",
    description: "cowork.integrations.description.accounting",
    category: "cowork.enterprise.integrations.category.businessSystems",
    canConnect: false,
  },
  {
    label: "QuickBooks",
    logoPath: "/template-logos/quickbooks.svg",
    description: "cowork.integrations.description.accounting",
    category: "cowork.enterprise.integrations.category.businessSystems",
    canConnect: false,
  },
  {
    label: "Notion",
    logoPath: "/template-logos/notion.svg",
    description: "cowork.integrations.description.notion",
    category: "cowork.enterprise.integrations.category.productivity",
    canConnect: false,
  },
  {
    label: "Dropbox",
    logoPath: "/template-logos/dropbox.svg",
    description: "cowork.integrations.description.dropbox",
    canConnect: false,
  },
  {
    label: "Box",
    logoPath: "/template-logos/box.svg",
    description: "cowork.integrations.description.box",
    canConnect: false,
  },
  {
    label: "Confluence",
    logoPath: "/template-logos/confluence.svg",
    description: "cowork.integrations.description.confluence",
    canConnect: false,
  },
  {
    label: "Jira",
    logoPath: "/template-logos/jira.svg",
    description: "cowork.integrations.description.jira",
    canConnect: false,
  },
  {
    label: "GitHub",
    logoPath: "/template-logos/github.svg",
    description: "cowork.integrations.description.github",
    canConnect: false,
  },
  {
    label: "GitLab",
    logoPath: "/template-logos/gitlab.svg",
    description: "cowork.integrations.description.gitlab",
    canConnect: false,
  },
  {
    label: "Amazon S3",
    logoPath: "/template-logos/aws.svg",
    description: "cowork.integrations.description.aws",
    canConnect: false,
  },
  {
    label: "Google Cloud",
    logoPath: "/template-logos/google-cloud-storage.svg",
    description: "cowork.integrations.description.google-cloud-storage",
    canConnect: false,
  },
  {
    label: "Azure Blob Storage",
    logoPath: "/template-logos/azure-blob-storage.svg",
    description: "cowork.integrations.description.azure-blob-storage",
    canConnect: false,
  },
  {
    label: "Figma",
    logoPath: "/template-logos/figma.svg",
    description: "cowork.integrations.description.figma",
    canConnect: false,
  },
  {
    label: "HubSpot",
    logoPath: "/template-logos/hubspot.svg",
    description: "cowork.integrations.description.hubspot",
    canConnect: false,
  },
  {
    label: "Asana",
    logoPath: "/template-logos/asana.svg",
    description: "cowork.integrations.description.asana",
    canConnect: false,
  },
  {
    label: "Linear",
    logoPath: "/template-logos/linear.svg",
    description: "cowork.integrations.description.linear",
    canConnect: false,
  },
  {
    label: "Trello",
    logoPath: "/template-logos/trello.svg",
    description: "cowork.integrations.description.trello",
    canConnect: false,
  },
  {
    label: "Zendesk",
    logoPath: "/template-logos/zendesk.svg",
    description: "cowork.integrations.description.zendesk",
    canConnect: false,
  },
  {
    label: "Intercom",
    logoPath: "/template-logos/intercom.svg",
    description: "cowork.integrations.description.intercom",
    canConnect: false,
  },
  {
    label: "Webflow",
    logoPath: "/template-logos/webflow.svg",
    description: "cowork.integrations.description.webflow",
    canConnect: false,
  },
  {
    label: "WordPress",
    logoPath: "/template-logos/wordpress.svg",
    description: "cowork.integrations.description.wordpress",
    canConnect: false,
  },
  {
    label: "1Password",
    logoPath: "/template-logos/1password.svg",
    description: "cowork.integrations.description.iam",
    canConnect: false,
  },
  {
    label: "ActiveCampaign",
    logoPath: "/template-logos/active-campaign.svg",
    description: "cowork.integrations.description.marketing",
    canConnect: false,
  },
  {
    label: "Adobe",
    logoPath: "/template-logos/adobe.svg",
    description: "cowork.integrations.description.productivity",
    canConnect: false,
  },
  {
    label: "ADP",
    logoPath: "/template-logos/adp.svg",
    description: "cowork.integrations.description.hr",
    canConnect: false,
  },
  {
    label: "Affinity",
    logoPath: "/template-logos/affinity.svg",
    description: "cowork.integrations.description.crmGeneric",
    canConnect: false,
  },
  {
    label: "Apollo",
    logoPath: "/template-logos/apollo.svg",
    description: "cowork.integrations.description.marketing",
    canConnect: false,
  },
  {
    label: "Attio",
    logoPath: "/template-logos/attio.svg",
    description: "cowork.integrations.description.crmGeneric",
    canConnect: false,
  },
  {
    label: "AutoTask",
    logoPath: "/template-logos/autotask.svg",
    description: "cowork.integrations.description.ticketing",
    canConnect: false,
  },
  {
    label: "Azure DevOps",
    logoPath: "/template-logos/azure-devops.svg",
    description: "cowork.integrations.description.devtools",
    canConnect: false,
  },
  {
    label: "BambooHR",
    logoPath: "/template-logos/bamboohr.svg",
    description: "cowork.integrations.description.hr",
    canConnect: false,
  },
  {
    label: "Basecamp",
    logoPath: "/template-logos/basecamp.svg",
    description: "cowork.integrations.description.productivity",
    canConnect: false,
  },
  {
    label: "Bitbucket",
    logoPath: "/template-logos/bitbucket.svg",
    description: "cowork.integrations.description.devtools",
    canConnect: false,
  },
  {
    label: "Braze",
    logoPath: "/template-logos/braze.svg",
    description: "cowork.integrations.description.marketing",
    canConnect: false,
  },
  {
    label: "Calendly",
    logoPath: "/template-logos/calendly.svg",
    description: "cowork.integrations.description.productivity",
    canConnect: false,
  },
  {
    label: "Canvas LMS",
    logoPath: "/template-logos/canvas-lms.svg",
    description: "cowork.integrations.description.knowledge",
    canConnect: false,
  },
  {
    label: "ClickUp",
    logoPath: "/template-logos/clickup.svg",
    description: "cowork.integrations.description.productivity",
    canConnect: false,
  },
  {
    label: "Contentful",
    logoPath: "/template-logos/contentful.svg",
    description: "cowork.integrations.description.content",
    canConnect: false,
  },
  {
    label: "Copper",
    logoPath: "/template-logos/copper.svg",
    description: "cowork.integrations.description.crmGeneric",
    canConnect: false,
  },
  {
    label: "DocuSign",
    logoPath: "/template-logos/docusign.svg",
    description: "cowork.integrations.description.documents",
    canConnect: false,
  },
  {
    label: "Drata",
    logoPath: "/template-logos/drata.svg",
    description: "cowork.integrations.description.compliance",
    canConnect: false,
  },
  {
    label: "Freshdesk",
    logoPath: "/template-logos/freshdesk.svg",
    description: "cowork.integrations.description.ticketing",
    canConnect: false,
  },
  {
    label: "Gong",
    logoPath: "/template-logos/gong.svg",
    description: "cowork.integrations.description.sales",
    canConnect: false,
  },
  {
    label: "Google Ads",
    logoPath: "/template-logos/google-ads.svg",
    description: "cowork.integrations.description.marketing",
    canConnect: false,
  },
  {
    label: "Greenhouse",
    logoPath: "/template-logos/greenhouse.svg",
    description: "cowork.integrations.description.hr",
    canConnect: false,
  },
  {
    label: "Gusto",
    logoPath: "/template-logos/gusto.svg",
    description: "cowork.integrations.description.hr",
    canConnect: false,
  },
  {
    label: "Ironclad",
    logoPath: "/template-logos/ironclad.svg",
    description: "cowork.integrations.description.documents",
    canConnect: false,
  },
  {
    label: "Klaviyo",
    logoPath: "/template-logos/klaviyo.svg",
    description: "cowork.integrations.description.marketing",
    canConnect: false,
  },
  {
    label: "Lever",
    logoPath: "/template-logos/lever.svg",
    description: "cowork.integrations.description.hr",
    canConnect: false,
  },
  {
    label: "Looker",
    logoPath: "/template-logos/looker.svg",
    description: "cowork.integrations.description.analytics",
    canConnect: false,
  },
  {
    label: "Mailchimp",
    logoPath: "/template-logos/mailchimp.svg",
    description: "cowork.integrations.description.marketing",
    canConnect: false,
  },
  {
    label: "Mailgun",
    logoPath: "/template-logos/mailgun.svg",
    description: "cowork.integrations.description.communication",
    canConnect: false,
  },
  {
    label: "Marketo",
    logoPath: "/template-logos/marketo.svg",
    description: "cowork.integrations.description.marketing",
    canConnect: false,
  },
  {
    label: "Miro",
    logoPath: "/template-logos/miro.svg",
    description: "cowork.integrations.description.productivity",
    canConnect: false,
  },
  {
    label: "Mixpanel",
    logoPath: "/template-logos/mixpanel.svg",
    description: "cowork.integrations.description.analytics",
    canConnect: false,
  },
  {
    label: "Monday.com",
    logoPath: "/template-logos/monday.svg",
    description: "cowork.integrations.description.productivity",
    canConnect: false,
  },
  {
    label: "OpenAI",
    logoPath: "/template-logos/openai.svg",
    description: "cowork.integrations.description.ai",
    canConnect: false,
  },
  {
    label: "Paychex",
    logoPath: "/template-logos/paychex.svg",
    description: "cowork.integrations.description.hr",
    canConnect: false,
  },
  {
    label: "Personio",
    logoPath: "/template-logos/personio.svg",
    description: "cowork.integrations.description.hr",
    canConnect: false,
  },
  {
    label: "Sage Intacct",
    logoPath: "/template-logos/sage-intacct.svg",
    description: "cowork.integrations.description.accounting",
    canConnect: false,
  },
  {
    label: "ServiceNow",
    logoPath: "/template-logos/servicenow.svg",
    description: "cowork.integrations.description.ticketing",
    canConnect: false,
  },
  {
    label: "Shopify",
    logoPath: "/template-logos/shopify.svg",
    description: "cowork.integrations.description.ecommerce",
    canConnect: false,
  },
  {
    label: "Stripe",
    logoPath: "/template-logos/stripe.svg",
    description: "cowork.integrations.description.payments",
    canConnect: false,
  },
  {
    label: "Workday",
    logoPath: "/template-logos/workday.svg",
    description: "cowork.integrations.description.hr",
    canConnect: false,
  },
  {
    label: "Workable",
    logoPath: "/template-logos/workable.svg",
    description: "cowork.integrations.description.hr",
    canConnect: false,
  },
  {
    label: "Zoho CRM",
    logoPath: "/template-logos/zoho-crm.svg",
    description: "cowork.integrations.description.crmGeneric",
    canConnect: false,
  },
  {
    label: "Zoom",
    logoPath: "/template-logos/zoom.svg",
    description: "cowork.integrations.description.communication",
    canConnect: false,
  },
] as const

export function integrationCategory(item: CoworkIntegrationCatalogItem): keyof typeof import("@/i18n/en").dict {
  if (item.category) return item.category
  const key = item.description
  if (
    [
      "cowork.integrations.description.documents",
      "cowork.integrations.description.aws",
      "cowork.integrations.description.google-cloud-storage",
      "cowork.integrations.description.azure-blob-storage",
      "cowork.integrations.description.dropbox",
      "cowork.integrations.description.box",
    ].includes(key)
  )
    return "cowork.enterprise.integrations.category.files"
  if (
    [
      "cowork.integrations.description.analytics",
      "cowork.integrations.description.ai",
      "cowork.integrations.description.knowledge",
    ].includes(key)
  )
    return "cowork.enterprise.integrations.category.data"
  if (
    [
      "cowork.integrations.description.communication",
      "cowork.integrations.description.slack",
      "cowork.integrations.description.microsoft-teams",
    ].includes(key)
  )
    return "cowork.enterprise.integrations.category.collaboration"
  if (
    [
      "cowork.integrations.description.productivity",
      "cowork.integrations.description.notion",
      "cowork.integrations.description.figma",
      "cowork.integrations.description.asana",
      "cowork.integrations.description.linear",
      "cowork.integrations.description.trello",
    ].includes(key)
  )
    return "cowork.enterprise.integrations.category.productivity"
  return "cowork.enterprise.integrations.category.businessSystems"
}

export function integrationConnectionProviderKey(connection: {
  provider_config_key?: string | null
  provider_key?: string | null
  provider?: string | null
}) {
  return normalizedIntegrationProviderKey(
    connection.provider_key || connection.provider || connection.provider_config_key,
  )
}

export function normalizedIntegrationProviderKey(providerKey: string | null | undefined) {
  const normalized = providerKey?.trim().toLowerCase()
  if (normalized === "sharepoint") return "sharepoint-online"
  if (normalized === "gdrive") return "google-drive"
  if (normalized === "onedrive") return "one-drive"
  return normalized
}
